import React from 'react';
import ChartGuideModal from '../../ChartGuideModal';

/**
 * کیتِ مشترکِ «راهنمای کامل» برای همه‌ی داشبوردها.
 * این بلوک‌ها ظاهر و ساختارِ یکدست می‌دهند تا هر داشبورد فقط «محتوای خودش» را بنویسد
 * (الگوبرداری از راهنمای داشبورد ارزیابی).
 */

/** قالبِ استانداردِ Modal راهنما؛ بدنه را با فاصله‌گذاریِ یکدست و RTL می‌پیچد. */
export const GuideModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}> = ({ isOpen, onClose, title, children }) => (
  <ChartGuideModal isOpen={isOpen} onClose={onClose} title={title}>
    <div className="space-y-10 text-right leading-relaxed">{children}</div>
  </ChartGuideModal>
);

/** یک بخشِ راهنما با آیکون و عنوان. */
export const GuideSection: React.FC<{
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}> = ({ icon, title, children }) => (
  <section>
    <div className="flex items-center gap-2 mb-3">
      <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-accent-purple/10 text-accent-purple shrink-0">
        {icon}
      </span>
      <h3 className="text-lg sm:text-xl font-semibold text-text-primary">{title}</h3>
    </div>
    {children}
  </section>
);

/** یک آیتمِ «برچسب: توضیح» داخلِ فهرست. */
export const GuideItem: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <li className="bg-bg-secondary/40 rounded-lg p-3 border border-border-primary">
    <span className="font-semibold text-text-primary">{label}: </span>
    <span className="text-text-secondary">{children}</span>
  </li>
);

/** یک ردیفِ توضیحِ رنگی برای «نمونه‌ی annotate‌شده». */
export const AnnotationRow: React.FC<{
  color: string;
  title: string;
  children: React.ReactNode;
}> = ({ color, title, children }) => (
  <li className="flex items-start gap-3">
    <span className={`${color} w-4 h-4 rounded-md shrink-0 mt-1 border border-border-primary`} />
    <div>
      <p className="font-semibold text-text-primary text-sm">{title}</p>
      <p className="text-text-secondary text-sm">{children}</p>
    </div>
  </li>
);

/** یک تراشهٔ راهنمای رنگ (legend). */
export const LegendChip: React.FC<{ className: string; label: string }> = ({
  className,
  label,
}) => (
  <div className="flex items-center gap-2">
    <span className={`${className} w-4 h-4 rounded border border-border-primary shrink-0`} />
    <span className="text-xs text-text-secondary">{label}</span>
  </div>
);

/** جعبهٔ نکته/اطلاعاتِ آبی‌رنگ با آیکونِ دلخواه. */
export const InfoCallout: React.FC<{
  icon?: React.ReactNode;
  children: React.ReactNode;
}> = ({ icon, children }) => (
  <div className="mt-4 flex items-start gap-2 text-sm text-text-secondary bg-status-info-bg border border-status-info rounded-lg p-3">
    {icon && <span className="text-status-info shrink-0 mt-0.5">{icon}</span>}
    <span>{children}</span>
  </div>
);
